






















































































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';

@Component({
  components: {},
})
export default class Sidebar extends Vue {
  @Action('doctors/setVisibility') private setDoctorsVisibility!: any;
  @Action('hospitals/setVisibility') private setHospitalsVisibility!: any;
  @Action('doctors/setHauptfach') private setHauptfach!: any;
  @Action('pharmacies/setVisibility') private setPharmaciesVisibility!: any;
  @Action('catchments/setVisibility') private setCatchmentsVisibility!: any;

  @Getter('doctors/visibility') private doctorsVisibility!: any;
  @Getter('doctors/hauptfach') private doctorsHauptfach!: any;
  @Getter('hospitals/visibility') private hospitalsVisibility!: any;
  @Getter('pharmacies/visibility') private pharmaciesVisibility!: any;
  @Getter('catchments/visibility') private catchmentsVisibility!: any;

  @Getter('catchments/activeLayerName') private activeLayerName!: any;
  @Getter('catchments/ageMicroraster') private ageMicrorasters!: any;
  @Getter('catchments/buyingPowerMicroraster') private buyingPowerMicrorasters!: any;
  @Getter('catchments/competitors') private competitors!: any;
  @Getter('catchments/microraster') private microrasters!: any;

  get doctorVisibility() {
    return this.doctorsVisibility;
  }

  set doctorVisibility(val) {
    this.setDoctorsVisibility(val);
  }

  get hospitalVisibility() {
    return this.hospitalsVisibility;
  }

  set hospitalVisibility(val) {
    this.setHospitalsVisibility(val);
  }

  get pharmacyVisibility() {
    return this.pharmaciesVisibility;
  }

  set pharmacyVisibility(val) {
    this.setPharmaciesVisibility(val);
  }

  get catchmentVisibility() {
    return this.catchmentsVisibility;
  }

  set catchmentVisibility(val) {
    this.setCatchmentsVisibility(val);
  }

  get hauptfach() {
    return this.doctorsHauptfach;
  }

  set hauptfach(val) {
    this.setHauptfach(val);
  }

  private drawer: boolean = true;
  private active: number = 0;
  private mapType: string = 'Straßennetz';
  private states: any =
    ['Alle',
      'Allgemeinmedizin', 'Anästhesiologie und Intensivmedizin', 'Arbeitsmedizin', 'Augenheilkunde und Optometrie',
      'Chirurgie', 'Frauenheilkunde und Geburtshilfe', 'Gerichtsmedizin',
      'Hals-, Nasen- und Ohrenkrankheiten', 'Haut- und Geschlechtskrankheiten', 'Hygiene und Mikrobiologie',
      'Immunologie', 'Innere Medizin', 'Kinder- und Jugendheilkunde', 'Kinder- und Jugendpsychiatrie',
      'Lungenkrankheiten', 'Medizinische Genetik', 'Medizinische Physiologie', 'Medizinische Radiologie-Diagnostik',
      'Medizinische und Chemische Labordiagnostik', 'Mund-, Kiefer- und Gesichtschirurgie', 'Neurologie',
      'Neurologie/Psychiatrie', 'Nuklearmedizin', 'Orthopädie und Orthopädische Chirurgie', 'Pathologie',
      'Physikalische Medizin u. Allgemeine Rehabilitation', 'Plastische, Ästhetische u Rekonstruktive Chirurgie',
      'Psychiatrie', 'Psychotherapie', 'Radiologie', 'Strahlentherapie-Radioonkologie',
      'Urologie', 'Zahn-, Mund- und Kieferheilkunde',
    ];


  private LAND_MAPPING = {
    1: 'Burgenland',
    2: 'Kärnten',
    3: 'NÖ',
    4: 'OÖ',
    5: 'Salzburg',
    6: 'Steiermark',
    7: 'Tirol',
    8: 'Vorarlberg',
    9: 'Wien',
  };

  @Watch('ageMicrorasters')
  private ageMicrorastersWatcher() {
    this.active = 1;
  }

  private getMicrorasterKeys(subStatistic: any): string[] {
    if (!subStatistic || subStatistic.length === 0) {
      return [];
    }
    const allKeys = Object.keys(subStatistic[0]);
    const demographyType = subStatistic[0].query_type;
    if (demographyType === 'COMMON') {
      return ['a_limit', 'ew17_total', 'nws_total', 'besch_total'];
    } else if (demographyType === 'GENDER') {
      return ['frauen_anteil', 'maenner_anteil'];
    } else if (demographyType === 'COMPANIES') {
      return ['count_companies'];
    } else if (demographyType === 'INFRASTRUCTURE_PRIVATE') {
      return ['count_infrastructure_private'];
    } else if (demographyType === 'DOCTORS') {
      return ['count_doctors'];
    } else if (demographyType === 'SPECIAL_DOCTORS') {
      return ['count_special_doctors'];
    }
    return allKeys.filter((key) => key !== 'query_type' && key !== 'unit');
  }

  private getMicrorasterLabel(key: string): string {
    switch (key) {
      case 'a_limit':
        return '';
      case 'nws_total':
        return 'Nebenwohnsitze';
      case 'besch_total':
        return 'Beschäftigte';
      case 'ew17_total':
        return 'Einwohner';
      case 'frauen_anteil':
        return 'Anteil Frauen %';
      case 'maenner_anteil':
        return 'Anteil Männer %';
      case 'count_companies':
        return 'Firmen';
      case 'count_infrastructure_private':
        return 'Frequenzbringer';
      case 'count_doctors':
        return 'Ärzte';
      case 'count_special_doctors':
        return 'Fachärzte';
      default:
        return key;
    }
  }

  private getMicrorasterSingleValue(key: string, value: any, index: number, record: { [key: string]: any }): string {
    if (key === 'a_limit') {
      return this.toHumanReadableNetworkUnit(value, record.unit);
    }
    if (value === '***') {
      return value;
    }
    if (['frauen_anteil', 'maenner_anteil'].indexOf(key) !== -1) {
      return new Intl.NumberFormat('de-DE', {maximumFractionDigits: 0}).format(value);
    }
    return new Intl.NumberFormat('de-DE', {maximumFractionDigits: 0}).format(value);
  }

  private toHumanReadableNetworkUnit(value: number | string, unit: 'sec' | 'meter') {
    if (typeof value === 'undefined' || value === null) {
      return '';
    }
    if (typeof value === 'string') {
      value = parseInt(value, 10);
    }
    if (isNaN(value)) {
      return '';
    }

    let humanReadableUnit: 'm' | 'km' | 'sec' | 'min' = 'm';
    switch (unit) {
      case 'sec':
        if (value >= 60) {
          value = value / 60;
          humanReadableUnit = 'min';
        } else {
          humanReadableUnit = 'sec';
        }
        break;
      case 'meter':
        if (value > 1000) {
          value = value / 1000;
          humanReadableUnit = 'km';
        } else {
          humanReadableUnit = 'm';
        }
        break;
    }
    if (humanReadableUnit as string === 'min' || humanReadableUnit as string === 'km') {
      value = Math.round(value * 100) / 100;
    }
    return ('' + value).replace('.', ',') + ' ' + humanReadableUnit;
  }

  private getLand(): string {
    if (this.ageMicrorasters && this.ageMicrorasters.length > 0) {
      // @ts-ignore
      return this.LAND_MAPPING[this.ageMicrorasters[0].land_id] || '-';
    } else {
      return '-';
    }
  }


  private getAgeMicrorasterSingleValue(
    key: string, value: any,
    index: number,
    record: { [key: string]: any },
  ): string {
    if (key === 'a_limit') {
      return this.toHumanReadableNetworkUnit(value, record.unit);
    }
    if (value === '***') {
      return value;
    }
    return new Intl.NumberFormat('de-DE', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(value);
  }

  private getAgeMicrorasterLabel(key: string): string {
    switch (key) {
      case 'alter_0_19':
        return '0 - 19 Jahre %';
      case 'alter_20_44':
        return '20 - 44 Jahre %';
      case 'alter_45_64':
        return '45 - 64 Jahre %';
      case 'alter_65':
        return '>= 65 Jahre %';
      case 'alter_0_19_bld':
      case 'alter_20_44_bld':
      case 'alter_45_64_bld':
      case 'alter_65_bld':
        return this.getLand() + ' ∅';
      default:
        return '';
    }
  }

  private getAgeMicrorasterKeys() {
    if (!this.ageMicrorasters || this.ageMicrorasters.length === 0) {
      return [];
    }

    return Object.keys(this.ageMicrorasters[0])
      .filter((key) => key !== 'land_id' && key !== 'unit')
      .sort();
  }

  private getBuyingPowerMicrorasterSingleValue(
    key: string,
    value: any,
    index: number,
    record: { [key: string]: any },
  ): string {
    if (key === 'a_limit') {
      return this.toHumanReadableNetworkUnit(value, record.unit);
    }
    if (value === '***') {
      return value;
    }
    return new Intl.NumberFormat('de-DE', {maximumFractionDigits: 0}).format(value);
  }

  private getBuyingPowerMicrorasterLabel(key: string): string {
    switch (key) {
      case 'kk_per_ew':
        return 'Kaufkraft je Einwohner €';
      case 'kk_per_ew_bld':
        return this.getLand() + ' ∅';
      default:
        return '';
    }
  }

  private getBuyingPowerMicrorasterKeys() {
    if (!this.buyingPowerMicrorasters || this.buyingPowerMicrorasters.length === 0) {
      return [];
    }

    return Object.keys(this.buyingPowerMicrorasters[0])
      .filter((key) => key !== 'land_id' && key !== 'unit')
      .sort();
  }
}
